import Disclaimer from "../components/pages/Disclaimer";

export default [
    {
        path: '/disclaimer',
        component: Disclaimer,
        name: 'disclaimer'
    },
]
